import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { FaExclamation, FaTrash } from "react-icons/fa";
import { clearCart, removeItem, setPickupDetails } from '../reduxAuth/cartSlice';
import { toast } from 'react-toastify';

function CartScreen() {
  const [pickUpLocation, setPickUpLocation]                     = useState("");
  const [pickUpDate, setPickUpDate]                             = useState("");
  const [pickUpTime, setPickUpTime]                             = useState("");
  const [pickUpAdded, setPickUpAdded]                           = useState(false);

  const cartItems                                               = useSelector((state) => state.cart.items);

  // Calculate the total cost
  const totalCost = cartItems.reduce((total, item) => {
    return total + item.product.price * item.quantity;
  }, 0);

  const dispatch                                                = useDispatch();

  useEffect(() => {
    document.title = 'Cart | Stephenson Adventures';
  },[]);
  
  const handleRemoveItem = (itemId) => {
    // Dispatch the removeItem action with the product ID
    dispatch(removeItem(itemId));
  };

  const handleClearCart = () => {
    // Dispatch the clearCart action to remove all items
    dispatch(clearCart());
  };

  const handleTravelDetails = () => {
    if(pickUpLocation.length > 3){
      if(pickUpDate.length > 2){
        if(pickUpTime.length > 2){
          setPickUpAdded(true);
        }else {
          toast.danger("Please add the time for pickup."); 
        }
      }else {
        toast.danger("Please add date of the pickup."); 
      }
    }else {
      toast.danger("Please add location.");
    }
  }

  const handleProceedCheckout = async () => {
    try{

      const pickUP = {
        "location": pickUpLocation,
        "date" : pickUpDate, 
        "time" : pickUpTime
      }
      console.log(pickUP);

      dispatch(setPickupDetails(pickUP));
    
      // Redirect to checkout page
      window.location.href = '/checkout';
    }catch(err){
      console.log(err);
    }
  }

  return (
    <div className="standard-ountline">
        <div className="standard-area">CartScreen
          <div className="container">
            <div className="checkout-container">
              <div className="fl-cover70">

                <div className="cart-listing">
                  <div className="cart-layer">
                    <div className="flexme">
                        <div className="icon-item-check">
                          <span><FaExclamation /></span>
                        </div>
                        <div className="ic-item-check-head">
                          Check your product before you checkout.
                          <div className="sub-ic-item-check">
                            Ensure every detail is perfect before completing purchase
                          </div>
                        </div>
                    </div>
                  </div>
                  {
                  cartItems.length === 0 ? (
                      <div className="cart-items">
                         <div className="pd20">
                            <h2>Your cart is empty</h2>
                         </div>
                      </div>
                    ) : (
                      <div className="cart-items">
                        <div className="trash-cart" onClick={handleClearCart}>
                          <FaTrash/> Remove All
                        </div>
                        {cartItems.map((item) => (
                          <div key={item.product._id} className="cart-item">                         
                            <div className="cart-item-image">
                              <img src={item.product.img_url} className="img-cart" />
                            </div>
                            <div className="cart-item-content">
                                <div className="content-checkout">
                                  <h3>{item.product.name}</h3>
                                  <p className="ct-price">Price: R {item.product.price}</p>
                                  <div>Days: {item.product.number_of_days}</div>
                                  <div>Duration: {item.product.duration}</div>
                                </div>
                                <div className="calculate-checkout">
                                   <div className="check-buttons">
                                      <button className="btn btn-introvet-small"> - </button>
                                        <div className="num-input">
                                          {item.quantity}
                                        </div>
                                      <button className="btn btn-introvet-small" > + </button>
                                   </div>
                                  <div className="remove-item">
                                    <button 
                                      className="btn btn-trashing"
                                      onClick={() => handleRemoveItem(item.product._id)} // Call handleRemoveItem with the product ID
                                      >
                                      <FaTrash /> Remove
                                    </button>
                                  </div>
                                </div>
                            </div>
                            
                          </div>
                        ))}
                      </div>
                    )
                  }
                </div>
              </div>
              <div className="fl-cover30">
                <div className="check-out-box">
                    <h3 className="check-title">Checkout</h3>
                    <div className="item-info-checkout">
                       <h4 className="sub-check">PICK UP</h4>
                      {
                        pickUpAdded ?
                        <div className="show-pickup">
                           <p className="flexspace-between">
                             <div className="tit-label">Pick up Location</div>
                             <div className="selected-label">{pickUpLocation}</div>
                           </p>
                           <p className="flexspace-between">
                             <div className="tit-label">Pick up Date</div>
                             <div className="selected-label">{pickUpDate}</div>
                           </p>
                           <p className="flexspace-between">
                             <div className="tit-label">Pick up Time</div>
                             <div className="selected-label">{pickUpTime}</div>
                           </p>
                           <button className="btn btn-activator btn-full mgtop10" onClick={() => setPickUpAdded(false)}>
                               Update
                            </button>
                        </div>
                        :
                        <div className="form-input-location">
                            <div className="txtSmall1 ">Location</div>
                            <input
                              className="form-control " 
                              type="text" 
                              placeholder="Pick Up Location" 
                              value={pickUpLocation} 
                              onChange={(e) => setPickUpLocation(e.target.value)}/>

                              <div className="txtSmall1 mgtop10">Date</div>
                              <input
                                className="form-control" 
                                type="date" 
                                placeholder="Pick Up Location" 
                                value={pickUpDate} 
                                onChange={(e) => setPickUpDate(e.target.value)}/>

                              <div className="txtSmall1 mgtop10">Time</div>
                              <input
                                className="form-control " 
                                type="time" 
                                placeholder="Pick Up Location" 
                                value={pickUpTime} 
                                onChange={(e) => setPickUpTime(e.target.value)}/>
                              {
                                 cartItems.length > 0 && 
                                 pickUpLocation.length > 3 &&
                                 pickUpDate.length > 2 &&
                                 pickUpTime.length > 2 && (
                                  <button className="btn btn-activator btn-full mgtop10" onClick={handleTravelDetails}>
                                    Confirm to Pick Up
                                  </button>
                                 )
                              }
                            
                        </div>
                      }
                        
                      
                    </div>
                    <div className="item-info-checkout">
                       <h4 className="sub-check">PRICING</h4>
                       <div className="total-info">
                          <div className="fl-left">
                            Total
                          </div>
                          <div className="fl-right">
                            R {totalCost.toFixed(2)}
                          </div>
                       </div>
                       {
                        pickUpAdded && (
                          <button className="btn btn-activator btn-full" onClick={() => handleProceedCheckout()}>
                            Proceed to Checkout
                          </button>
                        )
                       }
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default CartScreen